export const SCREEN_MEDIUM_MIN = 768;
export const SCREEN_LARGE_MIN = 992;
